/**
 * The blog. Newest first. Title and description of a post live in every
 * dictionary as `post.<slug>.title` / `post.<slug>.description`, so the index,
 * the metadata and the breadcrumbs never need the article body. The body is a
 * code-split module per locale (`src/posts/<slug>/i18n/<code>.js`) that only the
 * article page loads; `load` returns the post module with its figures and copy.
 *
 * `cover` is an artwork key from `src/data/artwork.js`; `accent` colours the
 * card the same way a game's accent does. `minutes` is checked against the
 * English word count by `npm run check`.
 */
export const posts = [
  {
    slug: 'helix-language-model-part-1',
    published: '2026-11-03',
    updated: null,
    cover: 'blog_helix_part1',
    accent: '#c0602f',
    topicKey: 'blog.topic.research',
    minutes: 8,
    load: () => import('../posts/helix-language-model-part-1/index.js'),
  },
];

export const postPath = (post) => `/blog/${post.slug}`;

export const findPost = (slug) => posts.find((post) => post.slug === slug) ?? null;
